import React from 'react'
import { useTranslation } from 'react-i18next'

import { IProps } from './interface/IProps'
import { MessageHighlight, TableMessage } from './style'

export const GenerateMessage = ({ total, redeemed }: IProps) => {
  const { t } = useTranslation()
  if (total === 0) {
    return (
      <TableMessage>
        😔
        {t(
          'No colleagues have been registered with your link, make sure that you shared it right to all social networks.',
        )}
      </TableMessage>
    )
  } else if (redeemed === 0) {
    return (
      <TableMessage>
        🚀 <MessageHighlight>{total}</MessageHighlight>
        {t(
          ' colleague(s) have already registered with your link, but unfortunately no one has purchased and paid a subscription.',
        )}
      </TableMessage>
    )
  } else if (redeemed === total) {
    return (
      <TableMessage>
        🔥 {t('Great news! ')}
        <MessageHighlight>{total}</MessageHighlight>
        {t(
          ' colleague(s) have registered with your link and all of them purchased and paid a subscription, giving you one free month.',
        )}
      </TableMessage>
    )
  } else {
    return (
      <TableMessage>
        🎉 <MessageHighlight>{total}</MessageHighlight>
        {t(' colleague(s) have already registered with your link, of which ')}
        <MessageHighlight>{redeemed}</MessageHighlight>
        {t(
          ' colleague(s) has purchased a paid subscription, giving you one free month.',
        )}
      </TableMessage>
    )
  }
}
